import './nav.css';

function Nav() {
    return (
      <div className="nav">
          <a className="nav-link" href="#home">Home</a>
          <a className="nav-link" href="#about">About</a>
          <a className="nav-link" href="#experience">Experience</a>
      </div>
    );
  }
  
  export default Nav;